import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  api: any;
  featureapi: any;
  loginData:any;
  docapi:any;
  healthapi:any;

  constructor(private httpClient: HttpClient) {
    this.api = environment.apiUrl;
    this.featureapi = environment.apiUrl;
    this.docapi = environment.doc2pdf;
    this.loginData = environment.queryUrl;
    this.healthapi = environment.apiUrlHealth;
  }

  private buildQueryParams(queryParams: any): HttpParams {
    let params = new HttpParams()

    if (queryParams && typeof queryParams === 'object') {
      Object.keys(queryParams).forEach(key => {
        const value = queryParams[key];
        if (value !== null && value !== undefined && value !== '') {
          params = params.set(key, value);
        }
      });
  }
  return params;
}

  // for apiUrlHealth endpoints
  sendHealthGetRequest(apiUrl:any){
    let finalUrl = this.healthapi + apiUrl;
    return this.httpClient.get(finalUrl, this.get_httpoptions());
  }

  // for queryUrl endpoints
  sendReGetRequest(apiUrl: any) {
    let finalUrl = this.loginData + apiUrl;
    return this.httpClient.get(finalUrl, this.get_httpoptions());
  }

  // GET with a JSON request body (same shape as sendReDeleteRequestWithBody).
  // Used by endpoints that stay GET but take an id-list payload instead of
  // stuffing every id into the query string.
  sendReGetRequestWithBody(apiUrl: any, body: any): Observable<Object> {
    let finalUrl = this.loginData + apiUrl; 
    console.log('sendReGetRequestWithBody finalUrl:', finalUrl);
    console.log('sendReGetRequestWithBody body:', body);
    return this.httpClient.request('POST', finalUrl, {
      body,
      ...this.get_httpoptions()
    });
  }

  sendCSVGetRequest(url: string): Observable<HttpResponse<any>> {
  return this.httpClient.get<any>(url, { observe: 'response' });
}


  sendPostDocRequest(api:any,data: any) {
    return this.httpClient.post(this.docapi,data ,{responseType: 'arraybuffer' });
  }

  sendRePostRequest(apiUrl: any, data: any): Observable<Object> {
    let finalUrl = this.loginData + apiUrl;
    return this.httpClient.post(finalUrl, data, this.get_httpoptions());
  }

  sendRePatchRequest(apiUrl: any, data: any): Observable<Object> {
    let finalUrl = this.loginData + apiUrl;
    return this.httpClient.patch(finalUrl, data, this.get_httpoptions());
  }

  sendRePutRequest(apiUrl: any, data: any): Observable<Object> {
    let finalUrl = this.loginData + apiUrl;
    return this.httpClient.put(finalUrl, data, this.get_httpoptions());
  }

  sendReDeleteRequest(apiUrl: any): Observable<Object> {
    let finalUrl = this.loginData + apiUrl;
    return this.httpClient.delete(finalUrl, this.get_httpoptions());
  }
   sendReDeleteRequestWithBody(apiUrl: any, body: any): Observable<Object> {
    let finalUrl = this.loginData + apiUrl;
    return this.httpClient.request('DELETE', finalUrl, {
      body,
      ...this.get_httpoptions()
    });
  }

  getFeaturesdata(apiUrl: any) {
    let finalUrl = this.featureapi + apiUrl;
    return this.httpClient.get(finalUrl, this.get_httpoptions());
  }
  
  // for apiUrl endpoints
  sendGetRequest(apiUrl: any, queryParams?: any) {
    let finalUrl = this.api + apiUrl;
    const params = this.buildQueryParams(queryParams);
    return this.httpClient.get(finalUrl, {
    params:params,
    ...this.get_httpoptions()
  });
  }

  sendPostRequest(apiUrl: any, data: any): Observable<Object> {
    let finalUrl = this.api + apiUrl;
    return this.httpClient.post(finalUrl, data, this.get_httpoptions());
  }

  sendPutRequest(apiUrl: any, data: any): Observable<Object> {
    let finalUrl = this.api + apiUrl;
    return this.httpClient.put(finalUrl, data, this.get_httpoptions());
  }

  sendPatchRequest(apiUrl: any, data: any): Observable<Object> {
    let finalUrl = this.api + apiUrl;
    return this.httpClient.patch(finalUrl, data, this.get_httpoptions());
  }

  sendUpdateRequest(apiUrl: any, data: any): Observable<Object> {
    let finalUrl = this.api + apiUrl;
    return this.httpClient.put(finalUrl, data, this.get_httpoptions());
  }

  sendDeleteRequest(apiUrl: any): Observable<Object> {
    let finalUrl = this.featureapi + apiUrl;
    return this.httpClient.delete(finalUrl, this.get_httpoptions());
  }

  sendDeleteRequestWithBody(apiUrl: any, body: any): Observable<Object> {
    let finalUrl = this.api + apiUrl;
    return this.httpClient.request('DELETE', finalUrl, {
      body,
      ...this.get_httpoptions()
    });
  }

  get_httpoptions(responseType?: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + localStorage.getItem('TOKEN')
      }),
      responseType: responseType || 'json' // Default to 'json' if responseType is not provided
    };
    return httpOptions
  }

  // Get id for support
  getSupport(id: any) {
    return this.httpClient.get(`${environment.apiUrl}/${id}`, {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + localStorage.getItem('TOKEN')
      })
    })
  }
  sendPostDecryptRequest(api:any,data: any) {
    return this.httpClient.post(api,data ,this.get_httpoptions('arraybuffer'));
  }
}